import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp"
import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"
import InputAdornment from "@mui/material/InputAdornment"
import Slider from "@mui/material/Slider"
import Stack from "@mui/material/Stack"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"

import { NumberInputPossibleValues } from "../../../../../../types/Browser"

export function FadeTextField({
  value,
  onChange,
}: {
  value: NumberInputPossibleValues
  onChange: (value: NumberInputPossibleValues) => void
}) {
  return (
    <TextField
      type="number"
      variant="standard"
      size="small"
      sx={{ ml: 2 }}
      style={{ maxWidth: "50px" }}
      placeholder="0"
      InputProps={{
        endAdornment: <InputAdornment position="end">s</InputAdornment>,
        inputMode: "numeric",
        // pattern: '[0-9]*',
      }}
      value={value}
      onChange={(e) => {
        const newValue = e.target.value
        if (newValue === "" || newValue === null) {
          onChange(null)
        } else if (!isNaN(Number(newValue))) {
          onChange(Number(Number(newValue) >= 0 ? newValue : 0))
        }
      }}
    />
  )
}

export default function FadeInControls({
  color,
  autoFadeInDuration = 0,
  setAutoFadeInDuration,
  fadeInOnPressDuration = 0,
  setFadeInOnPressDuration,
}: {
  color: string
  autoFadeInDuration: NumberInputPossibleValues
  setAutoFadeInDuration: (value: NumberInputPossibleValues) => void
  fadeInOnPressDuration: NumberInputPossibleValues
  setFadeInOnPressDuration: (value: NumberInputPossibleValues) => void
}) {
  return (
    <Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <ArrowUpwardIcon sx={{ mr: 1 }} />
        <Typography variant="h6">Fade-in on play:</Typography>

        <FadeTextField
          value={fadeInOnPressDuration || ""}
          onChange={setFadeInOnPressDuration}
        />
      </Box>
      <Box sx={{ pt: 1, width: "100%" }}>
        <Stack
          spacing={2}
          direction="row"
          sx={{ mb: 1, px: 2 }}
          alignItems="center"
        >
          <Slider
            style={{ color }}
            min={0}
            max={30}
            aria-label="Volume"
            value={Number(fadeInOnPressDuration)}
            onChange={(_e, v) => setFadeInOnPressDuration(Number(v))}
            valueLabelDisplay="auto"
            valueLabelFormat={(v) => `${v}s`}
          />
        </Stack>
      </Box>
      <Box sx={{ mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Sound will fade in for this many seconds whenever it starts playing.
        </Typography>
      </Box>
      {/* <Typography variant="body1">
        If the fade-in duration is longer than the time remaining, the sound may not reach maximum volume.
      </Typography> */}

      <Divider sx={{ my: 4 }} />

      <Box display="flex" flexDirection="row" alignItems="center">
        <KeyboardDoubleArrowUpIcon sx={{ mr: 1 }} />
        <Typography variant="h6">Auto fade-in duration:</Typography>

        <FadeTextField
          value={autoFadeInDuration || ""}
          onChange={setAutoFadeInDuration}
        />
      </Box>
      <Box sx={{ pt: 1, width: "100%" }}>
        <Stack
          spacing={2}
          direction="row"
          sx={{ mb: 1, px: 2 }}
          alignItems="center"
        >
          <Slider
            style={{ color }}
            min={0}
            max={30}
            aria-label="Volume"
            value={Number(autoFadeInDuration)}
            onChange={(_e, v) => setAutoFadeInDuration(Number(v))}
            valueLabelDisplay="auto"
            valueLabelFormat={(v) => `${v}s`}
          />
        </Stack>
      </Box>
      <Box sx={{ mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Sound will automatically fade in for this many seconds from the start.
        </Typography>
      </Box>
      {/* <Typography variant="body1">
        If the fade duration set here is longer than duration of sound, the sound will start at max volume and end on zero.
      </Typography> */}
    </Box>
  )
}
